export default __webpack_public_path__ + "static/media/logo-v1.fff2c626.png";